import { FirebaseOptions } from 'firebase/app';

/**
 * Global Firebase configuration for identity lookups
 * This matches the mobile app pattern where we initialize one global app
 * for identity lookups, then initialize tenant-specific apps dynamically
 */

const prodConfig: FirebaseOptions = {
  apiKey: 'AIzaSyBbL6dLPyfb5DN7CZuTXDcQgUq5XoUChlc',
  authDomain: 'hawkin-global.firebaseapp.com',
  projectId: 'hawkin-global',
  storageBucket: 'hawkin-global.firebasestorage.app',
  messagingSenderId: '451284198589',
  appId: '1:451284198589:web:9b5026c664325f98e743d4',
};

const devConfig: FirebaseOptions = {
  apiKey: 'AIzaSyDK8W3nOKoKdpCdyHmRWdh8ypy4qaI7WJE',
  authDomain: 'hawkin-global-dev.firebaseapp.com',
  projectId: 'hawkin-global-dev',
  storageBucket: 'hawkin-global-dev.firebasestorage.app',
  messagingSenderId: '267590547025',
  appId: '1:267590547025:web:24fbece9acf15eed726a70',
};

/**
 * Determine if we should use dev environment based on runtime checks
 * Checks both build-time ENVIRONMENT variable and runtime hostname
 */
const isDevelopment = (): boolean => {
  // Check build-time environment first
  if (ENVIRONMENT !== 'production') {
    return true;
  }

  // Check runtime hostname for dev environment
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Known dev hostname
    if (hostname === 'cloud.dev.hawkindynamics.com') {
      return true;
    }
    
    // Firebase preview URLs (PR previews, dev deployments)
    // Pattern: project--pr123-abc123.web.app or project--branch-abc123.web.app
    if (hostname.includes('hawkin-dev-project--') && hostname.endsWith('.web.app')) {
      return true;
    }
    
    // Firebase dev project URLs
    if (hostname === 'hawkin-dev-project.web.app' || hostname === 'hawkin-dev-project.firebaseapp.com') {
      return true;
    }
  }

  return false;
};

// Export the config based on runtime environment check
export const globalFirebaseConfig: FirebaseOptions = isDevelopment()
  ? devConfig
  : prodConfig;
